import StudentList from "../StudentList/StudentList.jsx";
import { useStudentDrop } from "../../../../../../hooks/useStudentDrop.jsx";
import styles from "./StudentListWithoutGroup.css.ts";

const NO_SMALL_TEAM_ID = null;

const StudentListWithoutGroup = ({ students, moveStudent, workshop }) => {
  const { isOver, drop } = useStudentDrop({
    targetGroupId: NO_SMALL_TEAM_ID,
    moveStudent,
  });

  return (
    <div ref={drop} className={styles.studentsWithoutGroup({ over: isOver })}>
      <StudentList
        students={students.filter(
          (student) => student.smallTeamId === NO_SMALL_TEAM_ID,
        )}
        workshop={workshop}
        isOver={isOver}
        drop={drop}
      />
    </div>
  );
};

export default StudentListWithoutGroup;
